export enum ReferenceType {
    Product,
    Service,
    Post,
    RentalService
}
